export default __webpack_public_path__ + "static/media/jsrbrtable_Lndsbg.4bd378a9.webp";